import { 
  usdtContract,
  safeContract,
  slvContract1, slvContract2, slvContract3, slvContract4,
  slvConAdd1, slvConAdd2, slvConAdd3, slvConAdd4

        } from "./ConAddsAndABIs"
import { ethers } from "ethers";
import React, { useEffect, useState } from "react";

function TheSafetyLadderVault(){

const [buySafeValue1, setBuySafeValue1] = useState(""); 
const [buySafeValue2, setBuySafeValue2] = useState(""); 
const [buySafeValue3, setBuySafeValue3] = useState(""); 
const [buySafeValue4, setBuySafeValue4] = useState(""); 

const [priceCeiling1, setPriceCeiling1] = useState('');
const [priceCeiling2, setPriceCeiling2] = useState('');
const [priceCeiling3, setPriceCeiling3] = useState('');
const [priceCeiling4, setPriceCeiling4] = useState('');

const [safeReceived1, setSafeReceived1] = useState('');
const [safeReceived2, setSafeReceived2] = useState('');
const [safeReceived3, setSafeReceived3] = useState('');
const [safeReceived4, setSafeReceived4] = useState('');

const [safeSold1, setSafeSold1] = useState('');
const [safeSold2, setSafeSold2] = useState('');
const [safeSold3, setSafeSold3] = useState('');
const [safeSold4, setSafeSold4] = useState('');

const [remainingSafe1, setRemainingSafe1] = useState('');
const [remainingSafe2, setRemainingSafe2] = useState('');
const [remainingSafe3, setRemainingSafe3] = useState('');
const [remainingSafe4, setRemainingSafe4] = useState('');

const [usdcPaid1, setUsdcPaid1] = useState('');
const [usdcPaid2, setUsdcPaid2] = useState('');
const [usdcPaid3, setUsdcPaid3] = useState('');
const [usdcPaid4, setUsdcPaid4] = useState('');

useEffect(() => {   

// - - - - - - - - - - 
const getSafetyVault1Details = async () => {
    const a = await slvContract1.getDlvSellingPrice() / 1000000 * 1.06;
    const b = a.toLocaleString(undefined, {minimumFractionDigits: 6, maximumFractionDigits: 6})
    const c = await safeContract.balanceOf(slvConAdd1) / (10 ** 18)
    const d = c.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})    
    const e = await slvContract1.totalSafeSold() / 1
    const f = e.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})
    const g = c + e
    const h = g.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})    
    const i = await slvContract1.totalUSDTGenerated() / 1
    const j = i.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})   
    setPriceCeiling1(b)
    setSafeReceived1(h)
    setSafeSold1(f)
    setRemainingSafe1(d)
    setUsdcPaid1(j)

  }  

  getSafetyVault1Details()
  .catch(console.error)

// - - - - - - - - - - 
const getSafetyVault2Details = async () => {
    const a = await slvContract2.getDlvSellingPrice() / 1000000 * 1.15;
    const b = a.toLocaleString(undefined, {minimumFractionDigits: 6, maximumFractionDigits: 6})
    const c = await safeContract.balanceOf(slvConAdd2) / (10 ** 18)
    const d = c.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})    
    const e = await slvContract2.totalSafeSold() / 1
    const f = e.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})
    const g = c + e
    const h = g.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})    
    const i = await slvContract2.totalUSDTGenerated() / 1
    const j = i.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})   
    setPriceCeiling2(b)
    setSafeReceived2(h)
    setSafeSold2(f)
    setRemainingSafe2(d)
    setUsdcPaid2(j)

  }  

  getSafetyVault2Details()
  .catch(console.error)

// - - - - - - - - - - 
const getSafetyVault3Details = async () => {
    const a = await slvContract3.getDlvSellingPrice() / 1000000 * 1.30;
    const b = a.toLocaleString(undefined, {minimumFractionDigits: 6, maximumFractionDigits: 6})
    const c = await safeContract.balanceOf(slvConAdd3) / (10 ** 18)
    const d = c.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})    
    const e = await slvContract3.totalSafeSold() / 1
    const f = e.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})
    const g = c + e
    const h = g.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})    
    const i = await slvContract3.totalUSDTGenerated() / 1
    const j = i.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})   
    setPriceCeiling3(b)
    setSafeReceived3(h)
    setSafeSold3(f)
    setRemainingSafe3(d)
    setUsdcPaid3(j)

  }  

  getSafetyVault3Details()
  .catch(console.error)  

// - - - - - - - - - - 
const getSafetyVault4Details = async () => {
    const a = await slvContract4.getDlvSellingPrice() / 1000000 * 1.50;
    const b = a.toLocaleString(undefined, {minimumFractionDigits: 6, maximumFractionDigits: 6})
    const c = await safeContract.balanceOf(slvConAdd4) / (10 ** 18)
    const d = c.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})    
    const e = await slvContract4.totalSafeSold() / 1
    const f = e.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})
    const g = c + e
    const h = g.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})    
    const i = await slvContract4.totalUSDTGenerated() / 1
    const j = i.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})   
    setPriceCeiling4(b)
    setSafeReceived4(h)
    setSafeSold4(f)
    setRemainingSafe4(d)
    setUsdcPaid4(j)

  }  

  getSafetyVault4Details()
  .catch(console.error)  
})

const handleBuySafeValueChange1 = (e) => {
    setBuySafeValue1(e.target.value);
    }  
   
const handleBuySafeValueChange2 = (e) => {
    setBuySafeValue2(e.target.value);
    }    
    
const handleBuySafeValueChange3 = (e) => {
    setBuySafeValue3(e.target.value);
    } 

const handleBuySafeValueChange4 = (e) => {
    setBuySafeValue4(e.target.value);
    } 

const handleBuySafeValueSubmit1 = async (e) => {
    e.preventDefault();
    console.log(buySafeValue1)
    const price = await slvContract1.getDlvSellingPrice() / 1;
    const safePerUsd = 1000000 / price
    const inUsdc = buySafeValue1 / safePerUsd * 1.06
    const inUsdca = inUsdc.toLocaleString(undefined, {minimumFractionDigits: 6, maximumFractionDigits: 6})
    const uintValuea = ethers.utils.parseUnits(inUsdca, 6)
    const txna = await usdtContract.approve(slvConAdd1, uintValuea)
    await txna.wait();  
    const txnb = await slvContract1.buySafeFromSlv(buySafeValue1)
    await txnb.wait();
    setBuySafeValue1(0);
    }

const handleBuySafeValueSubmit2 = async (e) => {
    e.preventDefault();
    console.log(buySafeValue2)
    const price = await slvContract2.getDlvSellingPrice() / 1;
    const safePerUsd = 1000000 / price
    const inUsdc = buySafeValue2 / safePerUsd * 1.15
    const inUsdca = inUsdc.toLocaleString(undefined, {minimumFractionDigits: 6, maximumFractionDigits: 6})
    const uintValuea = ethers.utils.parseUnits(inUsdca, 6)
    const txna = await usdtContract.approve(slvConAdd2, uintValuea)
    await txna.wait();  
    const txnb = await slvContract2.buySafeFromSlv(buySafeValue2)
    await txnb.wait();
    setBuySafeValue2(0);
    }

const handleBuySafeValueSubmit3 = async (e) => {
    e.preventDefault();
    console.log(buySafeValue3)
    const price = await slvContract3.getDlvSellingPrice() / 1;
    const safePerUsd = 1000000 / price
    const inUsdc = buySafeValue3 / safePerUsd * 1.30
    const inUsdca = inUsdc.toLocaleString(undefined, {minimumFractionDigits: 6, maximumFractionDigits: 6})
    const uintValuea = ethers.utils.parseUnits(inUsdca, 6)
    const txna = await usdtContract.approve(slvConAdd3, uintValuea)
    await txna.wait();  
    const txnb = await slvContract3.buySafeFromSlv(buySafeValue3)
    await txnb.wait();
    setBuySafeValue3(0);
    }

const handleBuySafeValueSubmit4 = async (e) => {
    e.preventDefault();
    console.log(buySafeValue4)
    const price = await slvContract4.getDlvSellingPrice() / 1;
    const safePerUsd = 1000000 / price
    const inUsdc = buySafeValue4 / safePerUsd * 1.50
    const inUsdca = inUsdc.toLocaleString(undefined, {minimumFractionDigits: 6, maximumFractionDigits: 6})
    const uintValuea = ethers.utils.parseUnits(inUsdca, 6)
    const txna = await usdtContract.approve(slvConAdd4, uintValuea)
    await txna.wait();  
    const txnb = await slvContract4.buySafeFromSlv(buySafeValue4)
    await txnb.wait();
    setBuySafeValue4(0);
    }

return ( 
  <div>
        <h2>The Safety Ladder Vaults</h2><br/>

        <form style={{"textAlign": "center"}} onSubmit={handleBuySafeValueSubmit1}>
            <input style={{"width": "200px"}} type="number" className="form-control" placeholder="0" onChange={handleBuySafeValueChange1} value={buySafeValue1} /> <button style={{"width": "150px"}} type={"submit"} className="btn btn-success">Buy $SAFE for {priceCeiling1} USDC each</button>
        </form><br/> 

      <table className="tableA">
        <tbody>
            <tr>
                <th style={{"width": "75%"}}>Safety Ladder Vault Step 1 (6% Premium)</th>
                <th style={{"width": "25%"}}>Stats</th>
            </tr>
            <tr>
                <td>Price Ceiling 1</td>
                <td className="column2">{priceCeiling1} $SAFE</td>
            </tr>
            <tr>
                <td>Total SAFE Received</td>
                <td className="column2">{safeReceived1} $SAFE</td>
            </tr>               
            <tr>
                <td>Total SAFE Sold</td>
                <td className="column2">{safeSold1} $SAFE</td>
            </tr>   
            <tr>
                <td>Total SAFE Remaining</td>
                <td className="column2">{remainingSafe1} $SAFE</td>
            </tr>               
            <tr>
                <td>Total USDC Paid</td>
                <td className="column2">{usdcPaid1} $USDC</td>
            </tr>                                                                                                                           
        </tbody>               
      </table><br />
  
        <form style={{"textAlign": "center"}} onSubmit={handleBuySafeValueSubmit2}>
            <input style={{"width": "200px"}} type="number" className="form-control" placeholder="0" onChange={handleBuySafeValueChange2} value={buySafeValue2} /> <button style={{"width": "150px"}} type={"submit"} className="btn btn-success">Buy $SAFE for {priceCeiling2} USDC each</button>
        </form><br/> 

      <table className="tableA">
        <tbody>
            <tr>
                <th style={{"width": "75%"}}>Safety Ladder Vault Step 2 (15% Premium)</th>
                <th style={{"width": "25%"}}>Stats</th>
            </tr>
            <tr>
                <td>Price Ceiling 2</td>
                <td className="column2">{priceCeiling2} $SAFE</td>
            </tr>
            <tr>
                <td>Total SAFE Received</td>
                <td className="column2">{safeReceived2} $SAFE</td>
            </tr>               
            <tr>
                <td>Total SAFE Sold</td>
                <td className="column2">{safeSold2} $SAFE</td>
            </tr>   
            <tr>
                <td>Total SAFE Remaining</td>
                <td className="column2">{remainingSafe2} $SAFE</td>
            </tr>               
            <tr>
                <td>Total USDC Paid</td>
                <td className="column2">{usdcPaid2} $USDC</td>
            </tr>                                                                                                                           
        </tbody>               
      </table><br />  

        <form style={{"textAlign": "center"}} onSubmit={handleBuySafeValueSubmit3}>
            <input style={{"width": "200px"}} type="number" className="form-control" placeholder="0" onChange={handleBuySafeValueChange3} value={buySafeValue3} /> <button style={{"width": "150px"}} type={"submit"} className="btn btn-success">Buy $SAFE for {priceCeiling3} USDC each</button>
        </form><br/> 

      <table className="tableA">
        <tbody>
            <tr>
                <th style={{"width": "75%"}}>Safety adder Vault Step 3 (30% Premium)</th>
                <th style={{"width": "25%"}}>Stats</th>
            </tr>
            <tr>
                <td>Price Ceiling 3</td>
                <td className="column2">{priceCeiling3} $SAFE</td>
            </tr>
            <tr>
                <td>Total SAFE Received</td>
                <td className="column2">{safeReceived3} $SAFE</td>
            </tr>               
            <tr>
                <td>Total SAFE Sold</td>
                <td className="column2">{safeSold3} $SAFE</td>
            </tr>   
            <tr>
                <td>Total SAFE Remaining</td>
                <td className="column2">{remainingSafe3} $SAFE</td>
            </tr>               
            <tr>
                <td>Total USDC Paid</td>
                <td className="column2">{usdcPaid3} $USDC</td>
            </tr>                                                                                                                           
        </tbody>               
      </table><br />

        <form style={{"textAlign": "center"}} onSubmit={handleBuySafeValueSubmit4}>
            <input style={{"width": "200px"}} type="number" className="form-control" placeholder="0" onChange={handleBuySafeValueChange4} value={buySafeValue4} /> <button style={{"width": "150px"}} type={"submit"} className="btn btn-success">Buy $SAFE for {priceCeiling4} USDC each</button>
        </form><br/> 

      <table className="tableA">
        <tbody>
            <tr>
                <th style={{"width": "75%"}}>Safety Ladder Vault Step 4 (50% Premium)</th>
                <th style={{"width": "25%"}}>Stats</th>
            </tr>
            <tr>
                <td>Price Ceiling 4</td>
                <td className="column2">{priceCeiling4} $SAFE</td>
            </tr>
            <tr>
                <td>Total SAFE Received</td>
                <td className="column2">{safeReceived4} $SAFE</td>
            </tr>               
            <tr>
                <td>Total SAFE Sold</td>
                <td className="column2">{safeSold4} $SAFE</td>
            </tr>   
            <tr>
                <td>Total SAFE Remaining</td>
                <td className="column2">{remainingSafe4} $SAFE</td>
            </tr>               
            <tr>
                <td>Total USDC Paid</td>
                <td className="column2">{usdcPaid4} $USDC</td>
            </tr>                                                                                                                           
        </tbody>               
      </table><br />

  </div>
  
)

}


export default TheSafetyLadderVault;